module.exports = __webpack_public_path__ + "static/img/widget-3.ace3bc80.png";